function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickybohoShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-5b42577e-e970-497a-887d-34be58a5e06f",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87 72.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48.94,68.87c-1,0-1.81-.81-1.81-1.81s.81-1.81,1.81-1.81,1.81,.81,1.81,1.81-.81,1.81-1.81,1.81m0-7.25c-3,0-5.44,2.44-5.44,5.44s2.44,5.44,5.44,5.44,5.44-2.44,5.44-5.44-2.44-5.44-5.44-5.44m-21.75,7.25c-1,0-1.81-.81-1.81-1.81s.81-1.81,1.81-1.81,1.81,.81,1.81,1.81-.81,1.81-1.81,1.81m0-7.25c-3,0-5.44,2.44-5.44,5.44s2.44,5.44,5.44,5.44,5.44-2.44,5.44-5.44-2.44-5.44-5.44-5.44M87,3.62h-10.74l-13.2,54.37H14.76L0,10.86H70.77l2.64-10.86h13.59V3.62ZM5.14,14.49l12.3,39.89H60.2l9.69-39.89H5.14Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickybohoShop);
export default __webpack_public_path__ + "static/media/vicky boho - shop.6424123d179c56778b220bf871107c91.svg";
export { ForwardRef as ReactComponent };